export default __webpack_public_path__ + "static/media/pink-back.ca477a4e.svg";